// Vendor
import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

// Internal
import { Quote } from '@src/components/Quote';
import { DEFAULT_SAL_PROPS } from '@src/config/sal';

const getQuotes = graphql`
  query getQuotes {
    allQuotesJson {
      nodes {
        leftSide {
          author
          color
          quote
          logo {
            alt
            fileName
            maxWidth
          }
        }
        rightSide {
          author
          color
          quote
          logo {
            alt
            fileName
            maxWidth
          }
        }
      }
    }
  }
`;

const ResaleMomentum: React.FC = () => {
  // Hooks
  const data = useStaticQuery(getQuotes);

  // Setup
  const leftQuotes = data.allQuotesJson.nodes[0].leftSide;
  const rightQuotes = data.allQuotesJson.nodes[0].rightSide;

  // Styles
  const classesQuoteCol = 'flex content-center flex-wrap justify-center';

  // Markup
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderQuote = (item: any, index: number) => {
    const { author, color, quote, logo } = item;
    const delay = index * 50;

    return (
      <Quote
        author={author}
        color={color}
        delay={delay}
        key={index}
        logo={logo}
        quote={quote}
      />
    );
  };

  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS}>
        Industry Experts Agree: Resale is Set to Soar
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-8">
        <div className={classesQuoteCol}>{leftQuotes.map(renderQuote)}</div>
        <div className={classesQuoteCol}>{rightQuotes.map(renderQuote)}</div>
      </div>
    </div>
  );
};

export { ResaleMomentum };
